import { css } from '@emotion/react';

export default ({ loose, tight }) =>
  (theme) =>
    [
      css`
        &.fieldset--hidden {
          display: none;
        }
        .fieldset__label {
          display: block;
        }
        .fieldset__header {
          color: ${theme.color.brown2};
          font-size: 12px !important;
        }
        .fieldset__error {
          &:before {
            background-color: ${theme.color.warning};
            border: 2px solid ${theme.color.white};
            border-radius: 50%;
            line-height: 16px !important;
            content: '!';
            color: ${theme.color.white};
            display: inline-block;
            margin-right: 4px;
            text-align: center;
            width: 21px;
            height: 21px;
          }
          font-size: 14px;
          margin-top: 8px;
        }
      `,
      loose &&
        css`
          .fieldset__error {
            margin: 16px 0;
          }
        `,
      tight &&
        css`
          margin-bottom: 0 !important;
        `,
    ];
